import {breakpointMedium, breakpointSmall} from "../layout/layout.styles"
import {css} from "linaria";


export const bannerBase = css`
  display: flex;
  flex-direction: column;
  border-width: 2px 2px 2px 6px;
  border-style: solid;
  margin: 0.5rem 0;
  align-items: flex-start;

   & > * + * {
     margin-left: 1rem;
   }

  ${breakpointSmall} {
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }

  ${breakpointSmall} {
    > * {
      padding: 1rem 0rem;
      margin-left: 1rem;
    }
  }

  ${breakpointMedium} {
    justify-content: flex-start;
  }
`

export const bannerBodyVertical = css`
  display: flex;
  flex-direction: column;

  > *:first-child {
    padding-bottom: 8px;
  }
`

export const bannerBodyHorizontal = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`

export const bannerIcon = css`
  align-self: flex-start;
  margin-top: 0.7rem;
`

export const bannerTitle = css`
  font-size: 18px;
  font-weight: bold;
`

export const bannerAlert = css`
  border-color: #D43434;

  .${bannerTitle} {
    color: #D43434;
  }
`

export const bannerInfo = css`
  border-color: #000000;

  .${bannerTitle} {
    color: #000000;
  }
`
